import React from 'react';

const HistoryDropdown = ({ tasks, onSelect, dropdownRef }) => (
  <div ref={dropdownRef} className="history-dropdown">
    {tasks.length > 0 ? (
      <ul>
        {tasks.map(task => (
          <li key={task.id} onClick={() => onSelect(task.uuid)}>
            {(task.project_nickname || `Untitled`) + ` (Task ID:${task.id})`}
          </li>
        ))}
      </ul>
    ) : (
      <p>No tasks with terminology found.</p>
    )}
  </div>
);

export default HistoryDropdown;